module.exports = __webpack_public_path__ + "common/icon-app-raksul-9364569fba6f53a36673e71c8a2660dd.svg";